import { wrap, themeColor } from 'utils/styles'

export default wrap(
  (props) => `
    border-radius: 4px;
    path {
      fill: none;
      stroke-width: ${props.height}px;
      stroke-miterlimit: round;
    
      &.meter {
        stroke: ${themeColor('loadingBarMeterColor', props)};
      }

      &.bg {
        stroke: ${themeColor('loadingBarBgColor', props)}
      }
    }
  `
)
